export default {
  labels: {
    close: 'X',
    navigation: {
      toggle: 'Menu',
      home: 'Start',
      lite: 'Lite App',
      about: 'Über uns',
      contact: 'Kontakt',
      information: 'Informationen',
      'digital-dance': 'Digitaler Tanz',
      project: 'Projekt',
      process: 'Prozess',
      publications: 'Veröffentlichungen',
      partners: 'Kooperationspartner',
      institutions: 'Förderer und Partner'
    },
    'media-types': {
      'img': 'Bild',
      'video': 'Video',
      'iframe': 'IFrame'
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/de_DE.js